// EmailJS configuration
//
// EmailJS is used as the "email backend" for the enrollment form: when a
// visitor submits the enrollment form, the details are emailed directly to
// Passion Care 4 U's inbox via EmailJS's client-side API (no custom server
// required), IN ADDITION to being saved in Firestore so they show up on the
// Admin Dashboard.
//
// SETUP: create a free account at https://www.emailjs.com, add an Email
// Service (e.g. Gmail) and an Email Template, then fill in the three values
// below via your `.env` file. See ENROLLMENT_ADMIN_SETUP.md for full
// step-by-step instructions and the suggested template fields.

export const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
export const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
export const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
